/**
 * Sons das portas da cena, sintetizados aqui (sem arquivos de áudio de terceiros, como os avisos
 * de `notify.ts`): abrir é um rangido curto que sobe, fechar é um baque grave, e a porta trancada
 * chacoalha (três batidas metálicas rápidas).
 */
export type DoorSound = 'open' | 'close' | 'locked';

let ctx: AudioContext | null = null;

/** Ruído filtrado com envelope curto (batida). */
function knock(ac: AudioContext, at: number, freq: number, dur: number, gain: number): void {
  const length = Math.max(1, Math.round(ac.sampleRate * dur));
  const buffer = ac.createBuffer(1, length, ac.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < length; i++) data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / length, 3);
  const src = ac.createBufferSource();
  src.buffer = buffer;
  const filter = ac.createBiquadFilter();
  filter.type = 'bandpass';
  filter.frequency.value = freq;
  filter.Q.value = 6;
  const g = ac.createGain();
  g.gain.value = gain;
  src.connect(filter).connect(g).connect(ac.destination);
  src.start(at);
}

/** Tom que desliza (o rangido). */
function creak(ac: AudioContext, at: number, from: number, to: number, dur: number, gain: number): void {
  const osc = ac.createOscillator();
  osc.type = 'sawtooth';
  osc.frequency.setValueAtTime(from, at);
  osc.frequency.exponentialRampToValueAtTime(to, at + dur);
  const filter = ac.createBiquadFilter();
  filter.type = 'lowpass';
  filter.frequency.value = 900;
  const g = ac.createGain();
  g.gain.setValueAtTime(0.0001, at);
  g.gain.exponentialRampToValueAtTime(gain, at + 0.03);
  g.gain.exponentialRampToValueAtTime(0.0001, at + dur);
  osc.connect(filter).connect(g).connect(ac.destination);
  osc.start(at);
  osc.stop(at + dur + 0.02);
}

export function playDoorSound(kind: DoorSound, volume = 0.6): void {
  try {
    ctx ??= new AudioContext();
    if (ctx.state === 'suspended') void ctx.resume();
    const at = ctx.currentTime + 0.01;
    if (kind === 'open') {
      creak(ctx, at, 140, 260, 0.35, 0.08 * volume);
      knock(ctx, at, 400, 0.06, 0.5 * volume);
    } else if (kind === 'close') {
      knock(ctx, at, 160, 0.14, 0.9 * volume);
      knock(ctx, at + 0.02, 600, 0.05, 0.3 * volume);
    } else {
      for (let i = 0; i < 3; i++) knock(ctx, at + i * 0.09, 1800 + i * 150, 0.05, 0.45 * volume);
    }
  } catch {
    // sem Web Audio: fica sem som
  }
}
